<style lang="less" scoped>
    #flex-center {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #avatar-name {
        width: 24px;
        height: 24px;
        border-radius: 12px;
        background: var(--themeColor);
        font-size: 18px;
        font-weight: 700;
        color: #fff;
    }

    .remark {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 10;
        cursor:
            url("../assets/img/note/remark.svg") 0 16,
            auto;
        background-color: transparent;
        svg {
            width: 24px;
            height: 24px;
        }
        .add-view {
            position: absolute;
            left: 200px;
            top: 200px;
            cursor: auto;
            .add-view-icon {
                height: 32px;
                width: 32px;
                background-color: var(--themeColor) !important;
                border-radius: 18px 18px 18px 0;
                box-shadow:
                    0px 2px 4px 0px rgba(0, 0, 0, 0.05),
                    0px 4px 8px 0px rgba(0, 0, 0, 0.15);
            }
            .add-view-content {
                position: absolute;
                top: 0;
                left: 40px;
                border-radius: 6px;
                background-color: #fff;
                box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
                .input-box {
                    position: relative;
                    width: 256px;
                    padding: 8px;
                    .input-icon {
                        position: absolute;
                        right: 10px;
                        top: 10px;
                        height: 24px;
                        width: 24px;
                        border-radius: 4px;
                        background: rgba(0, 0, 0, 0.12);
                    }
                }
                .bottom-box {
                    padding: 8px;
                    border-top: 1px solid rgba(0, 0, 0, 0.08);
                    .bottom-submit {
                        float: right;
                        width: 24px;
                        height: 24px;
                        border-radius: 4px;
                        background-color: var(--themeColor);
                        cursor: pointer;
                    }
                }
            }
        }
        .avatar {
            #flex-center();
            position: absolute;
            width: 32px;
            height: 32px;
            border-radius: 16px 16px 16px 0;
            background: #fff;
            box-shadow:
                0px 2px 4px 0px rgba(0, 0, 0, 0.05),
                0px 4px 8px 0px rgba(0, 0, 0, 0.15);
            cursor: auto;
        }
        .avatar_active {
            border: 1px solid var(--themeColor);
        }
        .avatar-name {
            #flex-center();
            #avatar-name();
        }
        .avatar-name_filfull {
            opacity: 0.4;
        }
        .avatar-tip {
            position: absolute;
            left: 0;
            top: 0;
            .tip-area {
                width: 32px;
                height: 32px;
                border-radius: 16px 16px 16px 0;
            }
            /deep/ .ivu-tooltip-inner {
                max-width: 360px;
                background: #fff;
                color: #222;
            }
            /deep/ .ivu-tooltip-arrow {
                display: none;
            }
            .tip-content {
                display: flex;
                .tip-content-img {
                    #flex-center();
                    #avatar-name();
                    margin-right: 8px;
                }
                .tip-content-top {
                    margin-bottom: 8px;
                }
                .top-name {
                    font-size: 14px;
                    font-weight: 700;
                }
                .top-date {
                    margin-left: 8px;
                    font-size: 12px;
                    color: var(--text-color-tertiary);
                }
                .tip-content-text {
                    width: 240px;
                    white-space: normal;
                }
            }
        }
    }
</style>
<style lang="less">
    .remark-edit-modal {
        .ivu-modal-header {
            padding: 8px 16px;
        }
        .header {
            display: flex;
            justify-content: flex-end;
            .header-icon {
                width: 24px;
                height: 24px;
                margin-left: 4px;
                cursor: default;
            }
        }
        .edit-content {
            .list {
                max-height: 460px;
                overflow-y: auto;
                .list-item {
                    display: flex;
                    margin-bottom: 16px;
                }
                .list-item-img {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 24px;
                    height: 24px;
                    margin-right: 8px;
                    border-radius: 12px;
                    background: var(--themeColor);
                    font-size: 18px;
                    font-weight: 700;
                    color: #fff;
                }
                .list-item-content {
                    width: 456px;
                    .content-top {
                        display: flex;
                        justify-content: space-between;
                        .top-name {
                            font-size: 14px;
                            font-weight: 700;
                        }
                        .top-date {
                            margin-left: 8px;
                            font-size: 12px;
                            color: var(--text-color-tertiary);
                        }
                        .header-icon {
                            width: 24px;
                            height: 24px;
                            cursor: default;
                        }
                    }
                    .content-edit {
                        width: 450px;
                        padding: 8px;
                        border-radius: 4px;
                        background-color: #f5f5f5;
                        .input-box {
                            width: 434px;
                        }
                        .button-box {
                            display: flex;
                            justify-content: flex-end;
                            margin-top: 8px;
                            padding-top: 8px;
                            border-top: 1px solid rgba(0, 0, 0, 0.08);
                            button {
                                margin-left: 8px;
                            }
                        }
                    }
                }
            }
            .reply-form {
                border-radius: 4px;
                background-color: #f5f5f5;
                .input-box {
                    position: relative;
                    width: 488px;
                    padding: 8px;
                    .input-icon {
                        position: absolute;
                        right: 10px;
                        top: 10px;
                        height: 24px;
                        width: 24px;
                        border-radius: 4px;
                        background: rgba(0, 0, 0, 0.12);
                    }
                }
                .bottom-box {
                    padding: 8px;
                    border-top: 1px solid rgba(0, 0, 0, 0.08);
                    .bottom-submit {
                        float: right;
                        width: 24px;
                        height: 24px;
                        border-radius: 4px;
                        background-color: var(--themeColor);
                        cursor: pointer;
                    }
                }
            }
        }
    }
</style>

<template>
    <div
        v-show="isRemarkView"
        ref="remarkRef"
        class="remark"
        :style="{ width: `${width}px`, height: `${height}px` }"
        @click.stop="remarkClick"
        @mousemove.stop=""
        @mousedown.stop=""
        @mouseup.stop=""
        @dblclick.stop=""
    >
        <div
            class="avatar"
            v-for="(item, index) in list"
            :class="{ avatar_active: activeRemarkDate === item._date }"
            :key="index"
            :style="{ left: `${item._x}px`, top: `${item._y}px` }"
            @click.stop="editHandler(item)"
        >
            <div class="avatar-name" :class="{ 'avatar-name_filfull': item._completed }">
                {{ item._name.slice(0, 1) }}
            </div>
            <Tooltip class="avatar-tip" placement="right-start">
                <div
                    class="tip-area"
                    draggable="true"
                    @dragstart.stop="avatarDragstartHandler"
                    @dragend.stop="avatarDragendHandler($event, item)"
                ></div>
                <div slot="content" class="tip-content">
                    <div class="tip-content-img">{{ item._name.slice(0, 1) }}</div>
                    <div>
                        <div class="tip-content-top">
                            <span class="top-name">{{ item._name }}</span>
                            <span class="top-date">{{ formatDate(item._date) }}</span>
                        </div>
                        <div class="tip-content-text">
                            {{ item._list[0].msg }}
                        </div>
                    </div>
                </div>
            </Tooltip>
        </div>
        <div v-show="showAddView" ref="addView" class="add-view" @click.stop="">
            <div class="add-view-icon" draggable="true" @dragstart.stop="addIconDragstartHandler" @dragend.stop="addIconDragendHandler"></div>
            <div class="add-view-content">
                <div class="input-box">
                    <Input v-model.trim="addText" type="textarea" :autosize="{ minRows: 1, maxRows: 6 }" placeholder="新增一个评论"></Input>
                    <div v-show="addText === ''" class="input-icon">
                        <iconSymbol name="remark-submit"></iconSymbol>
                    </div>
                </div>
                <div v-show="addText !== ''" class="bottom-box">
                    <div class="bottom-submit" @click="addSubmit">
                        <iconSymbol name="remark-submit"></iconSymbol>
                    </div>
                    <div style="clear: both"></div>
                </div>
            </div>
        </div>
        <Modal ref="editModalRef" class="remark-edit-modal" v-model="showEditModal" :footer-hide="true" :closable="false">
            <div slot="header" class="header">
                <div v-if="editObj._completed">
                    <iconSymbol class="header-icon" name="fulfilled"></iconSymbol>
                </div>
                <div v-else @click="fulfillHandler">
                    <iconSymbol class="header-icon" name="fulfill"></iconSymbol>
                </div>
                <Dropdown @on-click="remarkMoreMenuClick">
                    <iconSymbol class="header-icon" name="remark-more"></iconSymbol>
                    <DropdownMenu slot="list">
                        <DropdownItem name="delete">删除</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
                <div @click="closeHandler">
                    <iconSymbol class="header-icon" name="remark-close"></iconSymbol>
                </div>
            </div>
            <div v-if="showEditModal" class="edit-content">
                <div class="list">
                    <div v-for="(item, index) in editObj._list" :key="index" class="list-item">
                        <div class="list-item-img">{{ item.name.slice(0, 1) }}</div>
                        <div class="list-item-content">
                            <div class="content-top">
                                <div>
                                    <span class="top-name">{{ item.name }}</span>
                                    <span class="top-date">{{ formatDate(item.date) }}</span>
                                </div>
                                <Dropdown @on-click="replyMoreMenuClick($event, item)">
                                    <iconSymbol class="header-icon" name="remark-more"></iconSymbol>
                                    <DropdownMenu slot="list">
                                        <DropdownItem name="edit">编辑</DropdownItem>
                                        <DropdownItem name="delete">删除</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </div>
                            <div v-if="item.showEdit" class="content-edit">
                                <div class="input-box">
                                    <Input v-model.trim="item.editMsg" type="textarea" :autosize="{ minRows: 1, maxRows: 6 }"></Input>
                                </div>
                                <div class="button-box">
                                    <Button size="small" @click="cancelEditReplayHandler(item)">取消</Button>
                                    <Button type="primary" size="small" @click="submitEditReplyHandler(item)">保存</Button>
                                </div>
                            </div>
                            <div v-else>
                                {{ item.msg }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="reply-form">
                    <div class="input-box">
                        <Input v-model.trim="replyText" type="textarea" :autosize="{ minRows: 1, maxRows: 6 }" placeholder="回复"></Input>
                        <div v-show="replyText === ''" class="input-icon">
                            <iconSymbol name="remark-submit"></iconSymbol>
                        </div>
                    </div>
                    <div v-show="replyText !== ''" class="bottom-box">
                        <div class="bottom-submit" @click="replySubmit">
                            <iconSymbol name="remark-submit"></iconSymbol>
                        </div>
                        <div style="clear: both"></div>
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script lang="ts">
    /**
     * @file 评论
     * @author luokq
     */

    import { Component, Vue, Watch, Prop } from "vue-property-decorator";
    import { cloneDeep } from "lodash";
    import dayjs from "dayjs";
    declare var egPoint: any;

    @Component({})
    export default class Remark extends Vue {
        @Prop() readonly width;
        @Prop() readonly height;

        list = [];
        activeRemarkDate = null;
        showAddView = false;
        addText = "";

        get userInfo() {
            return this.$store.state.user.userInfo;
        }

        get zoomValue(): number {
            return parseFloat(this.$store.state.ui.zoomValue);
        }
        @Watch("zoomValue")
        zoomValueChange() {
            const page = window["_view"]?.activePage();
            if (this.isRemarkView && page) {
                this.list = this.formatPosition(page.getRemarks());
            }
        }

        get activedPageIndex() {
            return this.$store.state.page.activedPageIndex;
        }
        @Watch("activedPageIndex")
        activedPageIndexChange() {
            const page = window["_view"].activePage();
            if (this.isRemarkView && page) {
                this.list = this.formatPosition(page.getRemarks());
                this.$bus.$emit("refreshRemarkList");
            }
        }

        get currentView() {
            return this.$store.state.ui.currentView;
        }
        get showRightPanel() {
            return this.$store.state.ui.showRightPanel;
        }

        get isRemarkView() {
            return this.$store.state.ui.isRemarkView;
        }
        set isRemarkView(v) {
            this.$store.commit("setStatus", {
                type: "isRemarkView",
                data: v,
            });
        }
        @Watch("isRemarkView")
        isRemarkViewChange(v) {
            const view = window["_view"];
            const page = window["_view"].activePage();
            if (!view || !page) {
                return;
            }

            if (v) {
                view._tool.endEdit();
                view._tool.selectObject(null);
                this.list = this.formatPosition(page.getRemarks());
                this.$bus.$emit("itemChosen", "remark");
                this.$bus.$emit("setRightViewTitle", "评论");
                this.$bus.$emit("refreshRemarkList");

                window.addEventListener("mousedown", this.closeRemarks);
            }

            // 右侧侧边栏显示的是评论列表时，关闭侧边栏
            if (!v && this.showRightPanel && this.currentView === "remark") {
                this.$bus.$emit("itemChosen", "remark");
            }

            this.activeRemarkDate = null;
            this.$bus.$emit("setRemarkListActive", this.activeRemarkDate);
        }

        closeRemarks = (e) => {
            const remarkRef = this.$refs.remarkRef as HTMLDivElement;
            const editModalRef: any = this.$refs.editModalRef;
            const editModalDom: HTMLDivElement = (editModalRef && editModalRef.$el) || null;
            const panelViewAreaDom = document.getElementById("panelViewArea") as HTMLDivElement;
            const bottomPanelDom = document.getElementById("bottomPanel") as HTMLDivElement;

            // 除了以下指定区域之外，鼠标点击之后都要退出评论模式
            if (
                remarkRef === e.target ||
                remarkRef.contains(e.target) ||
                editModalDom === e.target ||
                (editModalDom && editModalDom.contains(e.target)) ||
                panelViewAreaDom === e.target ||
                (panelViewAreaDom && panelViewAreaDom.contains(e.target)) ||
                bottomPanelDom === e.target ||
                (bottomPanelDom && bottomPanelDom.contains(e.target))
            ) {
                return;
            }

            this.isRemarkView = false;
            window.removeEventListener("mousedown", this.closeRemarks);
        };

        formatDate(date) {
            return dayjs(date).format("YYYY-MM-DD HH:mm");
        }

        // 修改位置坐标，在页面上显示时坐标是相对scene的
        formatPosition(list) {
            const view = window["_view"];
            const page = window["_view"].activePage();
            if (!view || !page) {
                return list;
            }

            list.forEach((item) => {
                const pt = view.pageToScene(new egPoint(item._x, item._y));
                item._x = pt.x;
                item._y = pt.y - 32;
            });
            return list;
        }

        remarkClick(e: MouseEvent) {
            if (this.showAddView) {
                this.showAddView = false;
            } else {
                this.showAddView = true;
                this.addText = "";
                const formDom = this.$refs.addView as HTMLDivElement;
                if (formDom) {
                    formDom.style.left = e.offsetX + "px";
                    formDom.style.top = e.offsetY - 32 + "px";
                }
            }

            this.activeRemarkDate = null;
            this.$bus.$emit("setRemarkListActive", this.activeRemarkDate);
        }

        addSubmit() {
            const view = window["_view"];
            const page = window["_view"].activePage();
            const formDom = this.$refs.addView as HTMLDivElement;
            if (this.addText === "" || !view || !page || !formDom) {
                return;
            }

            const x = Number(formDom.style.left.replace("px", ""));
            const y = Number(formDom.style.top.replace("px", "")) + 32;
            const pt = view.sceneToPage(new egPoint(x, y));
            page.addRemark({
                name: this.userInfo.nick_name || this.userInfo.user_name || this.userInfo.user_id,
                id: this.userInfo.user_id,
                x: pt.x,
                y: pt.y,
                msg: this.addText,
            });

            this.showAddView = false;
            this.list = this.formatPosition(page.getRemarks());
            this.$bus.$emit("refreshRemarkList");
        }

        editHandler(item) {
            this.replyText = "";
            const obj = cloneDeep(item);
            obj._list.forEach((listItem) => {
                listItem.showEdit = false;
                listItem.editMsg = "";
            });
            this.editObj = obj;
            this.showAddView = false;
            this.showEditModal = true;
            this.activeRemarkDate = item._date;
            this.$bus.$emit("setRemarkListActive", this.activeRemarkDate);
        }

        showEditModal = false;
        editObj: any = {};
        replyText = "";

        fulfillHandler() {
            const page = window["_view"].activePage();
            if (!page) {
                return;
            }

            page.filfullRemark(this.editObj);
            this.closeHandler();
            this.list = this.formatPosition(page.getRemarks());
            this.$bus.$emit("refreshRemarkList");
        }

        remarkMoreMenuClick(name) {
            if (name === "delete") {
                this.deleteHandler();
            }
        }

        deleteHandler() {
            const page = window["_view"].activePage();
            if (!page) {
                return;
            }

            page.deleteRemark(this.editObj);
            this.closeHandler();
            this.list = this.formatPosition(page.getRemarks());
            this.$bus.$emit("refreshRemarkList");
        }

        closeHandler() {
            this.showEditModal = false;
            this.editObj = {};
        }

        replySubmit() {
            const page = window["_view"].activePage();
            if (!page || this.replyText === "") {
                return;
            }

            const replyObj = {
                name: this.userInfo.nick_name || this.userInfo.user_name || this.userInfo.user_id,
                id: this.userInfo.user_id,
                date: new Date().getTime(),
                msg: this.replyText,
            };
            this.editObj._list.push({
                showEdit: false,
                editMsg: "",
                ...replyObj,
            });
            page.replyRemark(this.editObj, replyObj);
            this.list = this.formatPosition(page.getRemarks());
            this.$bus.$emit("refreshRemarkList");
            this.replyText = "";
        }

        replyMoreMenuClick(name, item) {
            if (name === "edit") {
                this.editReplyHandler(item);
            } else if (name === "delete") {
                this.deleteReplyHandler(item);
            }
        }

        editReplyHandler(item) {
            this.editObj._list.forEach((listItem) => {
                if (listItem.date === item.date) {
                    listItem.showEdit = true;
                    listItem.editMsg = listItem.msg;
                } else {
                    listItem.showEdit = false;
                    listItem.editMsg = "";
                }
            });
        }

        deleteReplyHandler(item) {
            const page = window["_view"].activePage();
            if (!page) {
                return;
            }

            if (this.editObj._list.length === 1) {
                this.deleteHandler();
                return;
            }

            const i = this.editObj._list.findIndex((listItem) => listItem.date === item.date);
            if (i >= 0) {
                this.editObj._list.splice(i, 1);
                page.deleteReplyRemarks(this.editObj, item);
                this.list = this.formatPosition(page.getRemarks());
                this.$bus.$emit("refreshRemarkList");
            }
        }

        cancelEditReplayHandler(item) {
            const i = this.editObj._list.findIndex((listItem) => listItem.date === item.date);
            if (i >= 0) {
                this.editObj._list[i].showEdit = false;
                this.editObj._list[i].editMsg = "";
            }
        }

        submitEditReplyHandler(item) {
            const page = window["_view"].activePage();
            if (!page || item.editMsg === "") {
                return;
            }

            const i = this.editObj._list.findIndex((listItem) => listItem.date === item.date);
            if (i >= 0) {
                this.editObj._list[i].showEdit = false;
                this.editObj._list[i].msg = item.editMsg;
                this.editObj._list[i].editMsg = "";

                const obj = cloneDeep(this.editObj._list[i]);
                delete obj.showEdit;
                delete obj.editMsg;
                page.editReplyRemarks(this.editObj, obj);
                this.list = this.formatPosition(page.getRemarks());
                this.$bus.$emit("refreshRemarkList");
            }
        }

        avatarDragStartOffsetX = 0;
        avatarDragStartOffsetY = 0;
        avatarDragstartHandler(e) {
            this.avatarDragStartOffsetX = e.offsetX;
            this.avatarDragStartOffsetY = e.offsetY;
        }
        avatarDragendHandler(e, item) {
            const view = window["_view"];
            const page = window["_view"].activePage();
            const x = item._x - this.avatarDragStartOffsetX + e.offsetX;
            const y = item._y - this.avatarDragStartOffsetY + e.offsetY + 32;
            const pt = view.sceneToPage(new egPoint(x, y));

            page.updatePositionRemarks(item, pt);
            this.list = this.formatPosition(page.getRemarks());
        }

        addIconDragStartOffsetX = 0;
        addIconDragStartOffsetY = 0;
        addIconDragstartHandler(e) {
            this.addIconDragStartOffsetX = e.offsetX;
            this.addIconDragStartOffsetY = e.offsetY;
        }
        addIconDragendHandler(e) {
            const formDom = this.$refs.addView as HTMLDivElement;
            if (formDom) {
                formDom.style.left = Number(formDom.style.left.replace("px", "")) - this.addIconDragStartOffsetX + e.offsetX + "px";
                formDom.style.top = Number(formDom.style.top.replace("px", "")) - this.addIconDragStartOffsetY + e.offsetY + "px";
            }
        }

        refreshRemarkView() {
            const page = window["_view"].activePage();
            if (!page || !this.isRemarkView) {
                return;
            }

            this.showAddView = false;
            this.showEditModal = false;
            this.list = this.formatPosition(page.getRemarks());
        }

        setRemarkViewActive(date) {
            this.activeRemarkDate = date;
        }

        created() {
            this.$bus.$on("refreshRemarkView", this.refreshRemarkView);
            this.$bus.$on("setRemarkViewActive", this.setRemarkViewActive);
        }

        beforeDestroy() {
            this.$bus.$off("refreshRemarkView", this.refreshRemarkView);
            this.$bus.$off("setRemarkViewActive", this.setRemarkViewActive);
        }
    }
</script>
